import Actions from '.';
import { get, post, deleteCall } from '../../../utils/api';
import { API_ERROR_MESSAGE, DEFAULT_RECORD_LIMIT } from '../../../constants';

const getUploadedOrders = () => (async (dispatch, getState) => {
    const { uploadedOrders: { status } } = getState();
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`order/upload-order-list?limit=${DEFAULT_RECORD_LIMIT}&status=${status}`);
        if (data.statusCode === 200 && data.response) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                list: data.response.orders || [],
                nextPageToken: data.response.nextPageToken,
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                list: [],
                nextPageToken: null,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            list: [],
            nextPageToken: null,
        }));
    }
});

const loadMoreOrders = () => (async (dispatch, getState) => {
    const { uploadedOrders: { nextPageToken, list } } = getState();
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`order/upload-order-list?nextPageToken=${nextPageToken}`);
        if (data.statusCode === 200 && data.response) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                list: [...list, ...data.response.orders],
                nextPageToken: data.response.nextPageToken,
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                nextPageToken: null,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            nextPageToken: null,
        }));
    }
});

const uploadQuotation = values => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const { id, gst, orderValue, file } = values
        const body = new FormData();
        body.append('gst', gst);
        body.append('orderValue', orderValue);
        body.append('file', file);
        const data = await post(`order/upload-order-quotation/${id}`, body, { contentType: 'multipart/form-data' });
        if (data.statusCode === 201) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message,
                success: true,
            }));
            dispatch(getUploadedOrders());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

const deleteOrders = id => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await deleteCall(`order/${id}`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
            }));
            dispatch(getUploadedOrders());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

export default {
    getUploadedOrders,
    loadMoreOrders,
    uploadQuotation,
    deleteOrders
}